import { DateFormatPipe } from './../shared/pipes/date-format.pipe';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyChipInputEvent as MatChipInputEvent } from '@angular/material/legacy-chips';
import { COMMA, ENTER, TAB, SEMICOLON } from '@angular/cdk/keycodes';
import { DataService } from '../shared/services/data.service';
import { DeliveryOptions } from '../model/deliveryOptions.model';
import { ExportTypes } from './../model/enums/export-type.enum';
import { DeliveryTypes } from './../model/enums/delivery-type.enum';
import { RateTableRequest } from '../model/rateTableRequest.model';
import { RateTableInfo } from '../model/rateTableInformation.model';
import { Download } from './../model/download.model';
import { DeviceDetectorService } from 'ngx-device-detector';

declare let $: any;

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.css']
})

export class DeliveryComponent {
  public deliveryOptions: DeliveryOptions;
  public DeliveryTypes = DeliveryTypes;
  public ExportTypes = ExportTypes;
  public title = 'Delivery Rates';
  public showEmailOption = false;
  public emails: string[] = new Array<string>();
  public isValidEmail = true;
  public isDesktop: boolean;
  public isMobile: boolean;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA, TAB, SEMICOLON];
  public exportTypes: any[] = [{ Name: 'PDF', IsSelected: true, ExportType: this.ExportTypes.PDF }
    , { Name: 'Excel', IsSelected: false, ExportType: this.ExportTypes.Excel }];
  public deliveryTypes: any[] = [{ Name: 'Download', IsSelected: true, DeliveryType: this.DeliveryTypes.Download }
    , { Name: 'Email', IsSelected: false, DeliveryType: this.DeliveryTypes.Email }];
  rateTableRequest: RateTableRequest = new RateTableRequest();
  rateTableInfo: RateTableInfo = new RateTableInfo();
  Id = 0;
  public progressBarValue = 0;
  public generatingRateTableComplete = false;
  public errorDownloading = false;
  public downloadCompletedWithError = false;
  public generatingRateTableEmail = false;
  public generatingRateTablePercent = 0;
  public showCloseButton: boolean = true;

  constructor(public dataService: DataService,
    private dialogRef: MatDialogRef<DeliveryComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private dateFormatPipe: DateFormatPipe,
    public deviceService: DeviceDetectorService) {
    this.rateTableInfo = data.rateTableInfo;
    this.Id = data.Id;
  }

  ngOnInit() {
    let instance = $.fn.deviceDetector;
    if (this.deviceService.isDesktop()) this.isDesktop = true;
    if (this.deviceService.isMobile() || this.deviceService.isTablet()) this.isMobile = true;
  }

  generate() {
    this.title = 'Generating ...';
    this.showCloseButton = false;
    const selectedExportTypes: number[] = this.exportTypes.filter(x => x.IsSelected).map(({ ExportType }) => ExportType);

    if (this.deliveryTypes.filter(x => x.IsSelected && x.DeliveryType == DeliveryTypes.Download).length > 0) {
      const downloads: Download[] = new Array<Download>();
      const date = this.dateFormatPipe.transform(new Date());
      selectedExportTypes.forEach(deliveryType => {
        switch (deliveryType) {
          case ExportTypes.Excel: {
            const downloadExcel: Download = {
              id: this.Id,
              fileName: this.rateTableInfo.Group.groupName + date + '.xlsx',
              url: this.dataService.getDownloadExcelURL(this.Id),
              mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              percent: 0,
              responseObservable: null,
              responseData: null
            };
            downloads.push(downloadExcel);
            break;
          }
          case ExportTypes.PDF: {
            const downloadPDF: Download = {
              id: this.Id,
              fileName: this.rateTableInfo.Group.groupName + date + '.pdf',
              url: this.dataService.getDownloadPDFURL(this.Id),
              mime: 'application/pdf',
              percent: 0,
              responseObservable: null,
              responseData: null
            };
            downloads.push(downloadPDF);
            break;
          }
        }
      });
      this.dataService.generatingRateTable = true;
      this.refreshProgressBar(1);

      this.dataService.startDownloads(downloads).subscribe(res => {
      }, err => {
        this.dataService.generatingRateTable = false;
      },
        () => {
          const completedCount = this.dataService.downloads.filter(i => i.responseData != null).length;
          if (completedCount === downloads.length) {
            this.generatingRateTablePercent = 100;
            this.dataService.generatingRateTable = false;
            this.generatingRateTableComplete = true;
            this.title = 'Success';
			 /*#595944 If both download and email option is selected then call the api 1 after another to avoid the excel corruption because of image binding code in excel.*/
			if (this.deliveryTypes.filter(x => x.IsSelected && x.DeliveryType == DeliveryTypes.Email).length > 0) {
			  this.dataService.generatingRateTable = true;

			  this.deliveryOptions = new DeliveryOptions(
				this.emails
				, selectedExportTypes
				, DeliveryTypes.Email
				, this.Id
			  );
			  this.dataService.generateRateTables(this.deliveryOptions).subscribe(
				res => { },
				err => { },
				() => {				 
				  this.dataService.generatingRateTable = false;
				  this.generatingRateTableComplete = true;				 
				}
			  );
			}
          } else {
            this.downloadCompletedWithError = true;
          }
        }
      );
    }

    if (this.deliveryTypes.filter(x => x.IsSelected && x.DeliveryType == DeliveryTypes.Email).length > 0 && this.deliveryTypes.filter(x => x.IsSelected && x.DeliveryType == DeliveryTypes.Download).length == 0) {
      this.dataService.generatingRateTable = true;

      this.deliveryOptions = new DeliveryOptions(
        this.emails
        , selectedExportTypes
        , DeliveryTypes.Email
        , this.Id
      );

      this.refreshProgressBar(1);
      this.dataService.generateRateTables(this.deliveryOptions).subscribe(
        res => { },
        err => { },
        () => {
          this.generatingRateTablePercent = 100;
          this.dataService.generatingRateTable = false;
          this.generatingRateTableComplete = true;
          this.title = 'Success';
        }
      );
    }
  }

  refreshProgressBar(Index: number) {
    if (this.dataService.generatingRateTable) {
      setTimeout(() => {
        var page = Index + 1;
        this.generatingRateTablePercent = (this.generatingRateTablePercent < 100) ? this.generatingRateTablePercent + 1 : 100;
        if (this.generatingRateTablePercent < 90)
          this.refreshProgressBar(page);
      }, 150);
    }
  }

  close() {
    this.dialogRef.close();
  }

  updateExportType(exportType: any) {
    if (!this.exportTypes.find(x => x.ExportType === exportType.ExportType).IsSelected) {
      this.exportTypes.find(x => x.ExportType === exportType.ExportType).IsSelected = true;
    } else {
      if (this.exportTypes.filter(x => x.IsSelected).length !== 1) {
        this.exportTypes.find(x => x.ExportType === exportType.ExportType).IsSelected = false;
      }
    }
    if (this.isDesktop) {
      //if its desktop and both pdf & excel or only pdf is selected --then enabled download
      let exportTypesIsSelected = this.exportTypes.filter(e => e.IsSelected);
      let exportTypesIsPdf = this.exportTypes.find(e => e.exportType == this.ExportTypes.PDF);
      if ((exportTypesIsSelected != undefined && exportTypesIsSelected.length == 2) ||
        (exportTypesIsPdf != undefined && exportTypesIsPdf.length > 0)) {
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Download).IsSelected = true;
      }
    }

    if (this.isMobile) {
      //if its mobile and both pdf & excel are selected --then disable download
      let exportTypesIsSelected = this.exportTypes.filter(e => e.IsSelected);
      if ((exportTypesIsSelected != undefined && exportTypesIsSelected.length == 2)) {
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Download).IsSelected = false;
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Email).IsSelected = true;
      }
      //if its mobile and either pdf or excel isei selected --then allow only one 
      if ((exportTypesIsSelected != undefined && exportTypesIsSelected.length == 1)) {
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Download).IsSelected = true;
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Email).IsSelected = false;
      }
      this.enabledEmailTxtBox();
    }
  }

  updateDeliveryType(deliveryType: any) {
    if (this.isDesktop) {
      //if email chip is selected/deselected
      // if(deliveryType.DeliveryType == DeliveryTypes.Email) {
      this.deliveryTypes.find(x => x.DeliveryType === deliveryType.DeliveryType).IsSelected = !deliveryType.IsSelected;
      // } 
      //download chip will be selected by default and it cannot be deselected so code is required here for it
    }

    if (this.isMobile) {
      //disable download and return if pdf and excel both are selected 
      if ((this.exportTypes.filter(e => e.IsSelected).length == 2 && deliveryType.DeliveryType == DeliveryTypes.Download)) {
        this.disableGenerateBtn();
        return;
      }

      if ((this.exportTypes.filter(e => e.IsSelected).length == 1 && deliveryType.DeliveryType == DeliveryTypes.Email)) {
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Email).IsSelected = true;
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Download).IsSelected = false;
      }

      if ((this.exportTypes.filter(e => e.IsSelected).length == 1 && deliveryType.DeliveryType == DeliveryTypes.Download)) {
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Email).IsSelected = false;
        this.deliveryTypes.find(x => x.DeliveryType === DeliveryTypes.Download).IsSelected = true;
      }
    }
    this.enabledEmailTxtBox();
    this.disableGenerateBtn();
  }

  enabledEmailTxtBox() {
    if (this.deliveryTypes.find(d => d.Name === 'Email').IsSelected) {
      if (this.emails.length === 0) {
        this.isValidEmail = true;
        this.emails.push(this.rateTableInfo.Broker.Email);
      }
      this.showEmailOption = true;
    } else {
      this.showEmailOption = false;
    }
  }

  addEmailForExport(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    this.isValidEmail = (value === '') ? true : this.isEmail(value.trim());
    if (this.isValidEmail) {
      if ((value || '').trim()) {
        this.emails.push(value.trim());
      }
      if (input) {
        input.value = '';
      }
    }
  }

  removeEmail(email: any): void {
    const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  isEmail(email: string): boolean {
    let isEmailResult: boolean;

    const regexp = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,19}$/);
    isEmailResult = regexp.test(email);

    return isEmailResult;
  }

  disableGenerateBtn() {
    let validEmail = false;
    let validExportOptions = false;
    let validDeliveryOptions = false;
    let validNotGeneratingRateTableEmail = false;

    if (this.isSelectedDeliveryType()) {
      validExportOptions = true;
    }

    if (this.deliveryTypes.filter(d => d.IsSelected).length > 0) {
      validDeliveryOptions = true;
    }

    if (this.isSelectedEmail()) {
      if (this.emails !== undefined && this.emails.length > 0) {
        validEmail = true;
        validNotGeneratingRateTableEmail = !this.generatingRateTableEmail;
      } else {
        validEmail = false;
      }
    } else {
      validNotGeneratingRateTableEmail = true;
      validEmail = true;
    }
    return (!validEmail || !validExportOptions || !validNotGeneratingRateTableEmail || !validDeliveryOptions);
  }

  isSelectedEmail() {
    return this.deliveryTypes.find(x => x.DeliveryType === this.DeliveryTypes.Email).IsSelected ? true : false;
  }

  isSelectedDeliveryType() {
    return this.exportTypes.filter(x => x.IsSelected).length > 0 ? true : false;
  }

  redirect() {
    this.dataService.redirect();
  }
}
